// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"463":"9083ab9b","904":"d9b66c50"}[chunkId] + ".chunk.css";
};